import { useCentralStore } from "@/dentlab/src/store/Central";
import { ClientEntityType } from "../../../../../../lib/supabase/supabaseTypes";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/dentlab/src/context/ToastContext";
import { Button } from "@/dentlab/src/components/ui/button";
import { getClientDisplayName } from "@/lib/utils/client-utils";

export const ManageInactiveClientsTab: React.FC = () => {
	const navigate = useNavigate();
	const { showToast } = useToast();
	const { inactiveClients, upsertClient } = useCentralStore((state) => ({
		inactiveClients: Object.values(state.clientsLookup).filter(
			(client: ClientEntityType) => client.is_inactive === true
		),
		upsertClient: state.upsertClient,
	}));

	const handleReactivateClient = async (client: ClientEntityType) => {
		try {
			await upsertClient({
				...client,
				is_inactive: false,
				inactive_reason: null,
			});
			showToast(`${getClientDisplayName(client)} wurde reaktiviert`, "success");
		} catch (error) {
			showToast("Fehler beim Reaktivieren des Kunden", "error");
		}
	};

	const handleGoToClient = (clientId: string) => {
		navigate(`/client/${clientId}`);
	};

	return (
		<div className="w-full">
			{inactiveClients.length === 0 ? (
				<div className="text-center py-8">
					<div className="text-sm">
						Keine inaktiven Kunden gefunden
					</div>
				</div>
			) : (
				<div className="overflow-x-auto">
					<table className="w-full table-auto border-collapse">
						<thead>
							<tr className="border-b border-gray-200">
								<th className="text-left py-3 px-4">
									<div className="text-sm font-medium">Name</div>
								</th>
								<th className="text-left py-3 px-4">
									<div className="text-sm font-medium">Grund</div>
								</th>
								<th className="text-center py-3 px-4">
									<div className="text-sm font-medium">Aktionen</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{inactiveClients.map((client) => (
								<tr
									key={client.id}
									className="border-b border-gray-100 hover:bg-gray-50"
								>
									<td className="py-3 px-4">
										<div className="text-sm">
											{getClientDisplayName(client)}
										</div>
										<div className="text-sm">
											{client.code}
										</div>
									</td>
									<td className="py-3 px-4">
										<div className="text-sm">
											{client.inactive_reason || "Kein Grund angegeben"}
										</div>
									</td>
									<td className="py-3 px-4">
										<div className="flex gap-2 justify-center">
											<Button
												variant="outline"
												size="sm"
												onClick={() => handleGoToClient(client.id as string)}
											>
												Anzeigen
											</Button>
											<Button
												variant="default"
												size="sm"
												onClick={() => handleReactivateClient(client)}
											>
												Reaktivieren
											</Button>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};